import styled from 'styled-components';

const Line = styled.div`
  background-color: grey;
  opacity: 0.25;
  position: absolute;
`;

const HorizontalLine = Line.extend`
  width: 100%;
  height: 1px;
  top: 50%;
`;

const VerticalLine = Line.extend`
  width: 1px;
  height: 100%;
  margin-left: 50%;
`;

const DiagonalLine = Line.extend`
  width: 100%;
  height: 100%;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%'><line x1='100%' y1='0' x2='0' y2='100%' stroke='grey' stroke-width='1'/></svg>")
    no-repeat;
`;

export { HorizontalLine, VerticalLine, DiagonalLine };



// WEBPACK FOOTER //
// ./src/components/Layout/Line.jsx